import React from 'react'
import { useLayoutEffect, useEffect, useState, useRef } from 'react';
import './ComponentsCss/LawyerList.css';
// axios 
import axios from 'axios';
import backButton from '../imgs/back.png';
const LawyerLists = () => {


    const [AllLawyerData, SetAllLawyerData] = useState();
    const [LawyerExpand, SetLawyerExpand] = useState(false);
    const [LawyerSelected, SetLawyerSelected] = useState(0);

    const [lawyerEduList, SetLawyerEduList] = useState();
    const [lawyerExpList, SetLawyerExpList] = useState();
    useEffect(() => {
        axiosAllLawyerData();
    }, []);

    useEffect(() => {
        if (AllLawyerData) {
            const tempEdu = AllLawyerData[LawyerSelected]?.lawyerEducation.split(":");
            const tempExp = AllLawyerData[LawyerSelected]?.lawyerExperience.split(":");
            // const answer_array = answer.split(',');
            SetLawyerEduList(tempEdu);
            SetLawyerExpList(tempExp);
        }

    }, [AllLawyerData, LawyerSelected]);

    // https://stepupkorea.kr/api/Lawyer/allLawyerData
    const axiosAllLawyerData = async () => {
        console.log(" axiosAllLawyerData ");

        var finalIP = "";
        // https://stepupkorea.kr/api/NewsList/getAllNews
        finalIP = "https://stepupkorea.kr/api/Lawyer/allLawyerData";
        try {
            const response = await axios.get(finalIP

            );
            if (response) {
                console.log(response.data);
                SetAllLawyerData(response.data);
                //SetNewsListsArray(response.data);
            } else {

            }

        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Missing Username or Password');
            } else if (err.response?.status === 401) {
                console.log('--Unauthorized');
            } else {
                console.log('ERR');
            }

        }
    }
    return (
        <>
            <div style={{ height: "150px" }}>
            </div>

            {
                LawyerExpand == true ?
                    <>

                        <div className='back-button-flex'>
                            <img src={backButton} style={{ width: "30px", height: "30px" }} onClick={() => SetLawyerExpand(false)} />
                        </div>
                        <div className='lawyer-list-exp-main-frame'>
                            {

                                AllLawyerData != null && AllLawyerData.length > 0 ?
                                    <div className='lawyer-details-box'>
                                        <div className='lawyer-details-box'>

                                            <img src={"https://stepupkorea.kr/images/lawyers/" + AllLawyerData[LawyerSelected].lawyerImageBig}
                                                className="lawyer-image" />
                                            <div className='lawyer-list-flex-col'>
                                                <div className='lawyer-list-text-xxl lawyer-list-text-black'> {AllLawyerData[LawyerSelected].lawyerName}  </div>
                                                <div className='lawyer-list-width-20' > 변호사  </div>
                                                <div className='lawyer-list-width-80'> <span className='lawyer-list-text-accent'> T. </span> {AllLawyerData[LawyerSelected].lawyerTel}   </div>
                                                <div className='lawyer-list-width-80'> <span className='lawyer-list-text-accent'> F. </span> {AllLawyerData[LawyerSelected].lawyerFax}   </div>
                                                <div className='lawyer-list-width-80'> <span className='lawyer-list-text-accent'> E. </span> {AllLawyerData[LawyerSelected].lawyerEmail}   </div>
                                            </div>
                                            <div className='lawyer-list-banner ' >
                                                소개
                                            </div>
                                            <div className='lawyer-list-text-nor display-linebreak'>
                                                {AllLawyerData[LawyerSelected].lawyerIntro}
                                            </div>
                                            <div style={{ marginBottom: "20px" }}>

                                            </div>

                                            <div className='lawyer-list-flex-col'>
                                                <div className='lawyer-list-text-xxl lawyer-list-margin-tb-10'> 경력</div>

                                                {
                                                    lawyerExpList != null && lawyerExpList.length > 0 ?
                                                        lawyerExpList.map((exp, index) => (
                                                            <li>{exp}</li>


                                                        ))
                                                        : null
                                                }
                                                <div className='lawyer-list-separator'></div>
                                                <div className='lawyer-list-text-xxl lawyer-list-margin-tb-10'>학력</div>

                                                {
                                                    lawyerEduList != null && lawyerEduList.length > 0 ?
                                                        lawyerEduList.map((edu, index) => (
                                                            <li>{edu}</li>


                                                        ))
                                                        : null
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    : null
                            }
                            <div style={{ marginBottom: "150px" }}>

                            </div>

                        </div>

                    </> :
                    <>
                        <div className='lawyer-list-main-frame'>
                            <div className='lawyer-list-text-xxl'>전문회원 소개</div>
                            <div className='lawyer-list-separator'></div>

                            <div className='lawyer-details-main-box-row' style={{ marginBottom: "10px" }}>

                                {

                                    AllLawyerData != null && AllLawyerData.length > 0 ?
                                        AllLawyerData.map((lawyerData, index) => (


                                            <div className='lawyer-responsive-box' onClick={() => { SetLawyerExpand(true); SetLawyerSelected(index) }}>

                                                <img src={"https://stepupkorea.kr/images/lawyers/" + lawyerData.lawyerImageBig}
                                                    className="lawyer-image" />
                                                <div className='lawyer-list-flex-col'>
                                                    <div className='lawyer-list-text-xxl lawyer-list-text-black'> {lawyerData.lawyerName}  </div>
                                                    <div className='lawyer-details-box-row' >
                                                        <div className='lawyer-list-width-20' > 변호사  </div>
                                                        <div className='lawyer-list-width-80 lawyer-list-text-right'> <span className='lawyer-list-text-accent'> T. </span> {lawyerData.lawyerTel}   </div>
                                                    </div>

                                                </div>
                                            </div>



                                        ))
                                        : null
                                }
                            </div>
                            <div style={{ marginBottom: "150px" }}>

                            </div>
                        </div>

                    </>
            }
        </>
    )
}

export default LawyerLists
